import { isDefined } from '@sgme/fp';
import { Select } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';
import type { AutoCloseGrowlAfter as AutoCloseGrowlAfterType } from '@/store/userPreferences/state.ts';

const AutoCloseGrowlAfter = () => {
  const { formatMessage } = useIntl();
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = ({ value }: { autoCloseGrowlAfter: string; value: string }): void => {
    sgwtWebAnalytics?.trackEvent('Header', 'user preferences, general tab, auto close growl', value);
    updateUserPreferences({
      ...userPreferences,
      autoCloseGrowlAfter: value !== 'None' ? (Number(value) as AutoCloseGrowlAfterType) : null,
    });
  };

  const itemList = [
    {
      autoCloseGrowlAfter: formatMessage({ id: 'userPreferences.label.autoCloseGrowlAfter.manually' }),
      value: 'None',
    },
    {
      autoCloseGrowlAfter: formatMessage({ id: 'userPreferences.label.autoCloseGrowlAfter.custom' }, { seconds: '5' }),
      value: '5000',
    },
    {
      autoCloseGrowlAfter: formatMessage({ id: 'userPreferences.label.autoCloseGrowlAfter.custom' }, { seconds: '15' }),
      value: '15000',
    },
    {
      autoCloseGrowlAfter: formatMessage({ id: 'userPreferences.label.autoCloseGrowlAfter.custom' }, { seconds: '60' }),
      value: '60000',
    },
  ];

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="auto-close-growl-after">
        <FormattedMessage id="userPreferences.label.autoCloseGrowlAfter" />
      </label>
      <Select
        id="auto-close-growl-after"
        itemValue={(item) => item.value}
        selectedItemValue={
          isDefined(userPreferences.autoCloseGrowlAfter) ? String(userPreferences.autoCloseGrowlAfter) : 'None'
        }
        onChange={handleChange}
        itemsAsObjects={itemList}
        itemToString={({ autoCloseGrowlAfter }) => autoCloseGrowlAfter}
        className="w-auto"
      />
    </div>
  );
};

export default AutoCloseGrowlAfter;
